import { motion } from "framer-motion"
import { Link } from "react-router-dom"
import { Container, Title, Text, GradientText } from "../Greeting/styles"

const MyWell = () => (
  <Container>
    <motion.div
      initial="offscreen"
      animate="onscreen"
      variants={{
        offscreen: { opacity: 0, x: -50 },
        onscreen: { opacity: 1, x: 0 },
      }}
      transition={{ duration: 0.6 }}
      viewport={{ amount: 0.8 }}
    >
      <Title>My Well Ministry</Title>
      <Text>
        At My Well Ministry, I built the Giving mobile app in React Native,
        providing digital donation tools for faith-based organizations. I
        implemented Apple Pay integration, biometric authentication, and
        offline-capable donation flows. I led a TypeScript migration that
        reduced front-end load times by 40% and maintained PCI compliance and
        99.9% uptime across payment processing systems while shipping features
        iteratively in a small agile team.
      </Text>
      <Link className="link" to="https://www.mywell.org/" target="_blank">
        <GradientText>My Well</GradientText>
      </Link>
      <div className="tech-icon-container">
        <div className="tech-icons">React Native</div>
        <div className="tech-icons">Typescript</div>
        <div className="tech-icons">Node.js</div>
      </div>
    </motion.div>
  </Container>
)
export default MyWell
